import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

import { RadioService } from './radio.service';

@Component({
  selector: 'app-radio-group',
  exportAs: 'radioGroup',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    RadioService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupComponent),
      multi: true
    }
  ]
})
export class RadioGroupComponent implements OnInit, OnChanges, ControlValueAccessor, OnDestroy {
  onChange: Function = () => {};
  onTouched: Function = () => {};

  @Input() name: string | null = null;
  @Input() disabled: boolean = false;

  private value: any = null;
  private destroy$ = new Subject<void>();

  constructor(
    private radioService: RadioService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.radioService.selected$.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (this.value !== value) {
        this.value = value;
        this.onChange(this.value);
      }
    });

    this.radioService.touched$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.onTouched();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { disabled, name } = changes;
    if (disabled) {
      this.radioService.setDisabled(this.disabled);
    }
    if (name) {
      this.radioService.setName(this.name!);
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.radioService.select(obj);
    this.cdr.markForCheck();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = this.disabled || isDisabled;
    this.radioService.setDisabled(this.disabled);
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
